import createIcon from '../../createIcon';

/**
 * @component @name CameraFront
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMjBINVYyMkgxMFYyNEwxMyAyMUwxMCAxOFYyMFpNMTQgMjBWMjJIMTlWMjBIMTRaTTEyIDhDMTMuMSA4IDE0IDcuMSAxNCA2QzE0IDQuOSAxMy4xIDQgMTIgNEMxMC45IDQgMTAuMDEgNC45IDEwLjAxIDZDMTAuMDEgNy4xIDEwLjkgOCAxMiA4Wk0xNyAwSDdDNS45IDAgNSAwLjkgNSAyVjE2QzUgMTcuMSA1LjkgMTggNyAxOEgxN0MxOC4xIDE4IDE5IDE3LjEgMTkgMTZWMkMxOSAwLjkgMTguMSAwIDE3IDBaTTcgMkgxN1YxMi41QzE3IDEwLjgzIDEzLjY3IDEwIDEyIDEwQzEwLjMzIDEwIDcgMTAuODMgNyAxMi41VjJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CameraFront = createIcon('CameraFront', [
  [
    'path',
    {
      d: 'M10 20H5V22H10V24L13 21L10 18V20ZM14 20V22H19V20H14ZM12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10.01 4.9 10.01 6C10.01 7.1 10.9 8 12 8ZM17 0H7C5.9 0 5 0.9 5 2V16C5 17.1 5.9 18 7 18H17C18.1 18 19 17.1 19 16V2C19 0.9 18.1 0 17 0ZM7 2H17V12.5C17 10.83 13.67 10 12 10C10.33 10 7 10.83 7 12.5V2Z',
      key: '179s9y',
    },
  ],
]);

export default CameraFront;
